<template>
    <div class="bank-accounts-panel">
        <div class="main_content">
            <div class="bankList_list">
                <div class="cards">
                    <div class="cards_header">
                        <div class="left_txt">
                            <span>{{ $t('bankset.WithdrawalAccount') }}</span>
                            <span>({{ list.length }}/5)</span>
                            <button type="button" class="bank-refresh" :aria-label="({ es_MX: 'Actualizar', en_US: 'Refresh', pt_BR: 'Atualizar', ru_RU: 'Обновить' })[$i18n.locale] || 'Refresh'" @click.stop="getBankList"><BankUiIcon name="refresh" /></button>
                        </div>
                        <div class="eyes" @click.stop="isShowStar = !isShowStar">
                            <BankUiIcon :name="isShowStar ? 'visible' : 'hidden'" />
                        </div>
                    </div>
                    <div v-if="list.length">
                        <div class="cards_items" :class="{ 'act': selBank.id == item.id }" v-for="(item, index) in list"
                            :key="index">
                            <BankUiIcon name="card" />
                            <div class="bankInput_txt">
                                <div>{{ item.bankType }}({{ item.bankTypeName }})</div>
                                <div v-if="isShowStar" class="info">
                                    <span >{{ item.customerName }}</span>
                                    <i class="iconfont icon-fuzhiwenjian" @click.stop="onCopy(item.customerName)"></i>
                                </div>
                                <div v-else>{{ item.starAccount }}</div>
                            </div>
                            <div class="sel_btn" @click.stop="setDefaultBank(item)">{{ $t('Withdraw.SetDefault') }}</div>
                            <BankUiIcon class="chose" name="check" />
                        </div>
                    </div>
                    <div v-else class="empty">
                        <BankUiIcon class="bank-empty-icon" name="empty" />
                        <div class="bank-empty-copy">{{ ({ es_MX: 'Sin cuentas vinculadas', en_US: 'No linked accounts', pt_BR: 'Nenhuma conta vinculada', ru_RU: 'Нет привязанных счетов' })[$i18n.locale] || 'No linked accounts' }}</div>
                    </div>
                </div>
            </div>
            <div v-if="list.length < 5" class="manage-bottom">
                <div class="manage-item" @click.stop="onShowFormPopup('DebitCard')">
                    <div class="label">
                        <BankUiIcon name="card" />
                        <div>Debit Card</div>
                    </div>
                    <div class="add">{{ $t('Withdraw.Add') }}<BankUiIcon name="chevron" /></div>
                </div>
                <div class="manage-item" @click.stop="onShowFormPopup('CLABE')">
                    <div class="label">
                        <BankUiIcon name="bank" />
                        <div>CLABE</div>
                    </div>
                    <div class="add">{{ $t('Withdraw.Add') }}<BankUiIcon name="chevron" /></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getBankMexico } from '@/api/withdraw'
import BankUiIcon from './modules/BankUiIcon.vue'
export default {
    name: 'bankSetMexico',
    components: { BankUiIcon },
    data() {
        return {
            selBank: {},
            list: [],
            pageSize: 10,
            pageNo: 1,
            pages: 0,
            isShowStar: false,

            isShowLoadingPopup: false,
            LoadingNum: 0,

            isShowBanksetPopup: false,
            isShowBanksetPopupCNPJ: false,

            formPopupType: ''
        }
    },
    created() { },
    methods: {
        close() {
            this.$emit('close')
        },
        open() {
            this.getBankList()
        },
        getBankList() {
            getBankMexico({}, {
                custom: {
                    toast: false
                }
            }).then(res => {
                if (res.code) return
                const D = res?.result
                if (D && D.length) {
                    D.forEach(x => {
                        let lastFour = ''
                        lastFour = x.customerName.slice(-4)
                        x.starAccount = '****' + lastFour
                        if (x.customerType === 'DebitCard') {
                            x.bankTypeName = 'Debit Card'
                        }
                        if (x.customerType === 'CLABE') {
                            x.bankTypeName = 'CLABE'
                        }
                    })
                    this.list = D
                    const BankItem = this.$store.getters.bankItem
                    if (BankItem) {
                        this.selBank = JSON.parse(decodeURIComponent(BankItem))
                    } else {
                        this.selBank = D[0]
                    }
                }
            })
        },
        setDefaultBank(item) {
            this.selBank = item
            const BankItem = encodeURIComponent(JSON.stringify(item))
            this.$store.dispatch('user/setBankItem', BankItem)
        },
        onShowFormPopup(type) {
            this.formPopupType = type
            this.$emit('onShowPopup', 'withdrawPwdPopup')
            // this.$refs.withdrawPwdPopup.open()
        },
        WithDrawSucc() {
            if (this.formPopupType === 'DebitCard') {
                this.$emit('onShowPopup', 'banksetPopupDebit')
                // this.$refs.banksetPopupDebit.open()
            } else if (this.formPopupType === 'CLABE') {
                // this.$refs.banksetPopupCLABE.open()
                this.$emit('onShowPopup', 'banksetPopupCLABE')
            }
        },
        setBankSucc() {
            this.getBankList()
        }
    }
}
</script>

<style scoped lang="scss">
.bank-accounts-panel {
    color: #f7f6f5;
    font: 14px/1.4 Inter, "Segoe UI", Arial, sans-serif;
    text-align: left;
    * { box-sizing: border-box; }
    .main_content { overflow: visible; }
    .bankList_list { padding: 0 18px; }
    .cards { border: 1px solid #34343a; border-radius: 9px; background: #121418; padding: 12px; }
    .cards_header { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 8px; }
    .left_txt { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; min-width: 0; font-size: 16px; }
    .bank-refresh { display: grid; place-items: center; width: 36px; height: 36px; padding: 0; border: 0; color: #ff6055; background: none; cursor: pointer; }
    .bank-refresh .bank-ui-icon { width: 24px; height: 24px; }
    .eyes { display: grid; place-items: center; width: 36px; height: 36px; color: #b7b8c9; flex: 0 0 auto; cursor: pointer; }
    .eyes .bank-ui-icon { width: 25px; height: 25px; }
    .empty { min-height: 192px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 18px; padding: 22px 12px; color: #b7b8c9; }
    .bank-empty-icon { width: 82px; height: 82px; stroke-width: 1.1; overflow: visible; }
    .bank-empty-copy { font-size: 15px; text-align: center; }
    .cards_items { position: relative; display: flex; align-items: center; gap: 12px; min-height: 80px; border: 1px solid #42434e; border-radius: 8px; padding: 12px; margin-top: 10px; color: #f7f6f5; }
    .cards_items > .bank-ui-icon:not(.chose) { width: 28px; height: 28px; }
    .bankInput_txt { flex: 1; min-width: 0; font-size: 14px; overflow-wrap: anywhere; }
    .bankInput_txt > div:first-child { font-weight: 650; margin-bottom: 4px; }
    .bankInput_txt .info { display: flex; align-items: center; gap: 8px; }
    .info .iconfont { cursor: pointer; font-size: 15px; color: #b7b8c9; }
    .sel_btn { flex: 0 1 142px; min-height: 44px; display: flex; align-items: center; justify-content: center; text-align: center; padding: 6px 8px; border: 1px solid #727484; border-radius: 7px; cursor: pointer; font-size: 12px; line-height: 1.3; }
    .chose { display: none; }
    .cards_items.act { border: 2px solid #ff6055; padding: 11px; background: #302022; }
    .cards_items.act .bankInput_txt { padding-right: 28px; }
    .cards_items.act .sel_btn { display: none; }
    .cards_items.act .chose { display: block; position: absolute; right: 12px; top: calc(50% - 13px); width: 26px; height: 26px; padding: 5px; border-radius: 50%; color: #fff; background: #ff6055; }
    .manage-bottom { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin: 14px 18px 22px; }
    .manage-item { display: flex; flex-direction: column; gap: 16px; min-width: 0; min-height: 104px; border: 1px solid #42434e; border-radius: 9px; padding: 14px 16px; background: #121418; cursor: pointer; }
    .manage-item:hover { border-color: #ff6055; }
    .label { display: flex; align-items: center; gap: 12px; font-size: 16px; font-weight: 600; color: #f7f6f5; }
    .label .bank-ui-icon { width: 30px; height: 30px; }
    .add { display: flex; justify-content: flex-end; align-items: center; gap: 8px; margin-top: auto; color: #ff6055; font-size: 15px; font-weight: 600; }
    .add .bank-ui-icon { width: 17px; height: 17px; }
    .bank-refresh:focus-visible { outline: 2px solid #ff6055; outline-offset: 2px; border-radius: 5px; }
}
@media (max-width: 767px) {
    .bank-accounts-panel {
        .bankList_list { padding-inline: 16px; }
        .cards { padding: 10px; }
        .left_txt { font-size: 14px; gap: 4px; }
        .empty { min-height: 170px; padding-block: 20px; gap: 16px; }
        .bank-empty-icon { width: 72px; height: 72px; }
        .bank-empty-copy { font-size: 14px; }
        .manage-bottom { margin: 14px 16px 18px; gap: 10px; }
        .manage-item { min-height: 106px; padding: 13px 12px; gap: 16px; }
        .label { gap: 9px; font-size: 14px; }
        .label .bank-ui-icon { width: 27px; height: 27px; }
        .add { font-size: 14px; gap: 4px; }
        .cards_items { gap: 8px; padding: 10px; min-height: 80px; }
        .cards_items.act { padding: 9px; }
        .bankInput_txt { font-size: 13px; }
        .sel_btn { flex-basis: 104px; font-size: 11px; }
    }
}
@media (max-width: 359px) {
    .bank-accounts-panel {
        .bankList_list { padding-inline: 12px; }
        .manage-bottom { margin-inline: 12px; gap: 8px; }
        .manage-item { padding: 12px 10px; }
        .label { gap: 7px; font-size: 13px; }
        .label .bank-ui-icon { width: 24px; height: 24px; }
    }
}
</style>
